const en = {
  message: {

  }
}

export default en;